let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2mOtH")).then(() => parcelRequire('6HR6T'));